import { useGetChargeCodes } from '../../screens/Claims/LossAndDamage/hooks';
import FormSelectBox from '../Inputs/FormSelectBox';

const ClaimsChargeSelector = ({
  placeholder = 'Select a Charge Code',
  label = 'Charge Code',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  mode = '',
  disableValidation = false,
  isRemoved = false,
  labelWithValue = false,
}) => {
  const { data: options = [], isLoading } = useGetChargeCodes();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      mode={mode}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
      isRemoved={isRemoved}
      labelWithValue={labelWithValue}
      shouldUseNativeSelect
    />
  );
};

export default ClaimsChargeSelector;
